import { intersection, map } from "lodash";
import { ACCEPTING_NEW_PATIENT_REASON, fieldTypes, CREATE_FORM_FIELDS, FIELD_TYPES_BY_SPECIALTY, UPDATE_FORM_FIELDS } from "../constants";

const mapFormValuesToRequest = (formValues, fields, { isPrincipal } = {}) => {
  const params = {};

  fields.forEach((fieldType) => {
    switch (fieldType) {
      case fieldTypes.PRACTICE_TEAM:
        params.practiceTeamId = formValues[fieldType].value;
        break;
      case fieldTypes.MAX_PANEL:
        params.maxSize = parseInt(formValues[fieldType]);
        break;
      case fieldTypes.ACCEPT_NEW_PATIENTS:
        params.acceptNewPatients = formValues[fieldType];
        break;
      case fieldTypes.NEW_PATIENTS_DAILY_LIMIT:
        params.dailyNewPatientLimit = parseInt(formValues[fieldType]);
        break;
      case fieldTypes.NEW_PATIENT_STATES:
        if (formValues[fieldTypes.ACCEPT_NEW_PATIENTS]) {
          params.newPatientStates = formValues[fieldTypes.NEW_PATIENT_STATES];
        }
        break;
      case fieldTypes.STATES:
        params.states = isPrincipal ? null : map(formValues[fieldTypes.STATES], 'value');
        break;
      case fieldTypes.SHARE_PANEL:
        params.sharedProviderIds = formValues[fieldTypes.SHARE_PANEL].map(({ value }) => parseInt(value));
        break;
      default:
        throw new Error(`Unknown field type: ${fieldType}`);
    }
  });

  return params;
};

const getAcceptingNewPatientsReasonCd = (acceptingNewPatients) => {
  return acceptingNewPatients ? ACCEPTING_NEW_PATIENT_REASON.on_by_admin : ACCEPTING_NEW_PATIENT_REASON.off_by_admin
};

export const buildCreatePanelRequest = (providerId, formValues, { defaultPracticeId, specialtyCode, isPrincipal }) => ({
  providerId,
  practiceTeamId: defaultPracticeId,
  principal: isPrincipal,
  acceptingNewPatientsReasonCd: getAcceptingNewPatientsReasonCd(formValues[fieldTypes.ACCEPT_NEW_PATIENTS]),
  ...mapFormValuesToRequest(formValues, intersection(FIELD_TYPES_BY_SPECIALTY[specialtyCode], CREATE_FORM_FIELDS), { isPrincipal }),
});

export const buildUpdatePanelRequest = (practiceTeamParticipantId, formValues, { specialtyCode, isPrincipal }) => ({
  practiceTeamParticipantId,
  acceptingNewPatientsReasonCd: getAcceptingNewPatientsReasonCd(formValues[fieldTypes.ACCEPT_NEW_PATIENTS]),
  ...mapFormValuesToRequest(formValues, intersection(FIELD_TYPES_BY_SPECIALTY[specialtyCode], UPDATE_FORM_FIELDS), { isPrincipal }),
});
